export default {"src":"/_next/static/media/videoPlaceholder.2e0316df.svg","height":892,"width":1440,"blurWidth":0,"blurHeight":0};